import axios from './axios';

export const postSosRequest = coords =>
  axios.post('/sos', {
    location: {
      geometry: {
        coordinates: coords ? [coords.latitude, coords.longitude] : [],
        type: 'Point',
      },
      properties: {
        name: 'string',
      },
      type: 'Feature',
    },
  });

export const verifyPassword = password => axios.post('auth/users/me/password/verify', { password });

export const getOpenedAlarmsCount = () => axios.get('/sos/me');
